import { useLocalStorageStateWithMigrations } from 'hooks/useLocalStorageStateWithMigrations';
import { omit } from 'lodash';
import type { FunctionComponent, PropsWithChildren } from 'react';
import {
  ALL_FEATURE_FLAGS,
  ENVIRONMENT,
  FEATURE_FLAGS,
  featureFlagDescriptions,
} from 'utils/constants';
import { FeatureTogglesContext } from './FeatureTogglesContext';
import { featureTogglesDefaultValues } from './FeatureTogglesDefaultValues';
import { migrations } from './FeatureTogglesProvider.migrations';
import type { Features } from './FeatureTogglesProvider.types';

interface FeatureTogglesProviderProps {
  environments: string[];
}

export const FeatureTogglesProvider: FunctionComponent<
  FeatureTogglesProviderProps & PropsWithChildren
> = ({ children, environments }) => {
  const [features, setFeatures] = useLocalStorageStateWithMigrations<Features>(
    'featureToggles',
    featureTogglesDefaultValues,
    migrations
  );
  const filteredFeatures = omit(features, '_version');
  const isTogglingAllowed = environments.includes(ENVIRONMENT);

  return (
    <FeatureTogglesContext.Provider
      value={{
        features: isTogglingAllowed ? filteredFeatures : FEATURE_FLAGS,
        environmentsFeatureFlags: ALL_FEATURE_FLAGS,
        currentEnvironment: ENVIRONMENT,
        featureFlagDescriptions,
        setFeatures,
        isTogglingAllowed,
        environments,
      }}
    >
      {children}
    </FeatureTogglesContext.Provider>
  );
};
